export interface RLSCertUploadRequest {
  participant: string,
  pass_phrase: string,
  file: File
}

export const isCompleteRLSCertUploadRequest = (i: Partial<RLSCertUploadRequest>): i is RLSCertUploadRequest =>  {
  return !!i.participant && !!i.pass_phrase && !!i.file
}